import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { useEffect, useState } from 'react';

import { SubscriptionFormProps } from '.';
import { STRIPE_PUBLISH_KEY } from '../../src/env';
import { createSetupIntent } from '../../utils/backend-api/stripe';
import { Spinner } from '../BaseUI';
import PaymentMethod from './PaymentMethod';

const stripePromise = loadStripe(STRIPE_PUBLISH_KEY);
const PaymentForm = ({
  buttonText,
  currentTrialEndDate,
  currentPlan,
  referringSubscriberName,
  referringSubscriberGuid,
  stripeCustomerId,
}: SubscriptionFormProps) => {
  const [clientSecret, setClientSecret] = useState('');
  const isTrial = !!referringSubscriberName;

  useEffect(() => {
    (async () => {
      const { client_secret: clientSecret } = await createSetupIntent({
        stripe_customer_id: stripeCustomerId,
      });
      setClientSecret(clientSecret);
    })();
  }, [stripeCustomerId]);

  return (
    <>
      {clientSecret ? (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <PaymentMethod
            buttonText={buttonText}
            currentPlan={currentPlan}
            currentTrialEndDate={currentTrialEndDate}
            isTrial={isTrial}
            referringSubscriber={referringSubscriberName}
            referringSubscriberGuid={referringSubscriberGuid}
          />
        </Elements>
      ) : (
        <div className="text-center mt-16 mb-16">
          <Spinner />
        </div>
      )}
    </>
  );
};

export default PaymentForm;
